import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import CommonImage from '@components/CommonImage';
import CustomTooltip from '@components/CustomTooltip';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';

import { getShortName, packTag, setTag, STATIC_SET_CONSTANTS } from '@utils/Util';

const SupplierDesigns = ({ factoryPODetails }) => {
	const [search, setSearch] = useState('');
	const [productResponseList, setProductResponseList] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		if (factoryPODetails?.productResponseList?.length > 0) {
			setProductResponseList(factoryPODetails?.productResponseList);
		}
	}, [factoryPODetails?.productResponseList]);

	const onCloseViewModal = () => {
		dispatch(clearDesignViewModalInfo({}));
	};

	const setDesignIdToView = (product) => {
		dispatch(
			setDesignViewModalInfo({
				isShowMergeTechPack: product.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT,
				id: product.id,
				onCloseViewModal: (id) => onCloseViewModal(id),
				source: 'PRODUCT_LIST'
			})
		);
	};

	const renderDesigns = () => {
		return productResponseList?.map((item, idx) => (
			<div
				className={`single-design-card ${[STATIC_SET_CONSTANTS.SET_PRODUCT, STATIC_SET_CONSTANTS.PACK_PRODUCT].includes(item.setPackStyleFlag) ? 'set-design-card' : ''}`}
				key={`product_design_${item.id}_${idx}`}
				onClick={() => setDesignIdToView(item)}
			>
				<div className="card-top">
					<CommonImage src={item?.designDocuments?.[0]?.docUrl} isStatic={false} />
					{item.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT && (
						<CommonImage src={item?.designDocuments?.[1]?.docUrl} isStatic={false} />
					)}
					<div className="check-icon"></div>
					{item.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT && <div>{setTag()}</div>}
					{item.setPackStyleFlag === STATIC_SET_CONSTANTS.PACK_PRODUCT && <div>{packTag()}</div>}
				</div>
				<div className="card-content mt-2">
					<h3 className="regular-12 gray_dark_01 design-title">
						<CustomTooltip
							placement="top"
							arrowCenter={true}
							text={item?.referenceNumber}
							className={item?.referenceNumber?.length > 14 ? 'show' : 'hide'}
						>
							{getShortName(item?.referenceNumber, 14)}
						</CustomTooltip>
					</h3>
				</div>
			</div>
		));
	};

	const handleDesignSearch = (e) => {
		setSearch(e.target.value);
		let searchResult = e.target.value
			? productResponseList?.filter((item) =>
					item?.referenceNumber?.toLowerCase().includes(e.target.value.toLowerCase())
				)
			: factoryPODetails?.productResponseList;
		setProductResponseList(searchResult);
	};

	return (
		<div className="po-all-order-design">
			<div className="header border-0 d-flex justify-content-between">
				<div className="tilte">
					<h3 className="medium-14 mb-0 gray_dark_01">
						All Designs ({factoryPODetails?.productResponseList?.length})
					</h3>
				</div>
				<div className="m-0 search-filter">
					<div className="with-icon right-icon">
						<input
							type="text"
							placeholder="Search with design no"
							value={search}
							onChange={handleDesignSearch}
						/>
						<span className="right-icon cursor-pointer">
							<img src="/icons/search.png" alt="" />
						</span>
					</div>
				</div>
			</div>
			<div className="order-items">{renderDesigns()}</div>
		</div>
	);
};

export default SupplierDesigns;
